import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import ArrowDown from "@/assets/clients/arrow-down.svg";
import useLocale from "@/hooks/useLocale";

export default function ColoredHeader({
  backgroundImage,
  text,
  textBtn,
  link,
  path,
}) {
  const locale = useLocale();

  return (
    <div className="container px-[1rem] py-0 xl:px-[80px] md:py-[3rem] relative z-50 ColoredHeader">
      <SourceFlowImage
        src={backgroundImage}
        size="1678x720"
        alt="image-banner"
        className="min-h-[260px] w-full max-h-[720px] object-cover"
      />
      <div className="w-full h-full flex flex-col absolute top-0 left-0 py-5 md:pt-[0px] sm:pt-[32px] lg:pt-[64px] justify-between">
        <div className="flex flex-col items-center gap-10 justify-center">
          <h1 className="max-w-full xl:max-w-[1200px] leading-lg md:leading-xl xl:leading-[100px] xl:mt-24 md:mt-16 sm:mt-10 text-balance text-[30px]/[35px] md:text-[60px]/[70px] xl:text-[100px] text-center text-transparent bg-clip-text bg-gradient-to-r from-gradient-start to-gradient-end animate-gradient-x">
            <CustomSourceFlowText
              title={text}
              path={`dynamic1.${path}.header1`}
              locale={locale}
            />
          </h1>
          <div className="flex justify-center w-full h-10 md:h-[54px] lg:w-[100%] mt-4">
            <ExpandingButton
              url={link}
              color="white"
              bgColor="transparent"
              hoverBGColor="#ffffff"
              hoverColor="#150235"
            >
              {textBtn}
            </ExpandingButton>
          </div>
        </div>
        <div className="mt-3 mb-[1rem] sm:mt-0 sm:mb-[3rem] flex w-full justify-center">
          <ArrowDown />
        </div>
      </div>
    </div>
  );
}
